/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import Back from '../../../images/CardlessEMI/cardless-back.png';
import ValidatedInput from 'react-number-format';
import PopUp from '../../HOC/PopUp';
import CountDown from '../../Common/CountDownTimer';
import { sortTenures, EncryptUsingAes } from '../../Common/Function';
import BankDetails from './Components/BankDetails';
import downloadIcon from '../../../images/icons/download-icon.svg';

const ProcessScreen = ({
  token,
  mobileNumber,
  clearCheckEligibilityForCardlessEMIAction,
  checkPanCardEligibilityForCardlessEMIAction,
  validateOTPForCardlessEMIAction,
  checkSession,
  sessionExpires,
  paymentModeData,
  cardlessEMIData,
  selectedBank,
  setSelectedBank,
  selectedTenure,
  setselectedTenure,
  onProceed,
  orderConfirmationWithPanCard,
  merchantPaymentData,
  isProceedDisable,
  SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED,
  resendOTPForCardlessEMIAction,
  clearResendOTPData,
}) => {
  const [hdfcEtbTenures, setHdfcEtbTenures] = useState([]);
  const [iciciEtbTenures, setIciciEtbTenures] = useState([]);
  const [panNumber, setPanNumber] = useState('');
  const [isPanCardEligible, setIsPanCardEligible] = useState(false);
  const [panCardErrorMessage, setPanCardErrorMessage] = useState('');
  const [showOtpPopup, setShowOtpPopup] = useState(Boolean(false));
  const [otp, setOtp] = useState('');
  const [OTPValidationFailureMsg, setOTPValidationFailureMsg] = useState('');
  const [orderConfirmationFailureMsg, setOrderConfirmationFailureMsg] =
    useState('');
  const [panCardInputErrorMessage, setPanCardInputErrorMessage] = useState('');
  const [showHdfcEmiDetailsPopup, setShowHdfcEmiDetailsPopup] = useState(false);
  const [validateOtpAPIResponse, setValidateOtpAPIResponse] = useState({});
  const [termsAndConditionsCheckBox, setTermsAndConditionsCheckBox] =
    useState(false);
  const [dcEMIIssuer, setDcEMIIssuer] = useState({});
  const [submitButtonClicked, setSubmitButtonClicked] = useState(false);
  const [iciciDcEMIIssuer, setIciciDcEMIIssuer] = useState({});
  const [isIcici, setIsIcici] = useState(false);
  const [otpResended, updateOtpResended] = useState(false);
  const [encryptedPan, setEncryptedPan] = useState('');
  const [keyfactUrl, setKeyfactUrl] =useState('');

  const last5digitsOfPanCardRegex = /[0-9]{4}[a-zA-Z]/;
  const panCardRegex = /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/;
  const panEcryptionKey = process.env.REACT_APP_PAN_ENCRYPTION_KEY;

  const setDefaultState = () => {
    setIsPanCardEligible(false);
    setselectedTenure(false);
    setPanNumber('');
    setPanCardErrorMessage('');
    setOtp('');
    setOTPValidationFailureMsg('');
    setValidateOtpAPIResponse('');
    setTermsAndConditionsCheckBox('');
    setPanCardInputErrorMessage('');
    setOrderConfirmationFailureMsg('');
  };

  useEffect(() => {
    if(selectedBank.name === "ICICI") {
      setIsIcici(true);
        setIciciEtbTenures(iciciEtbTenures?.filter((tenure) => tenure.tenure_in_month <= selectedBank.tenure_in_month))
    } else {
      setIsIcici(false);
    }
  },[selectedBank])

  useEffect(() => {
    if ((isIcici && panNumber.length < 10) || (!isIcici && panNumber.length < 5)) {
      setIsPanCardEligible(false);
    } else if(isIcici) {
      setEncryptedPan(EncryptUsingAes(`000000${panNumber}`, panEcryptionKey));
    }
  }, [panNumber]);

  useEffect(() => {
    isPanCardEligible && setShowOtpPopup(Boolean(true));
  }, [isPanCardEligible]);

  useEffect(() => {
    if (paymentModeData) {
      const cardlessIssuer = paymentModeData.find(
        (paymentMode) => paymentMode.payment_mode_id === 19
      )?.data;
  
      let hdfcIssuer, iciciIssuer;
  
      if (cardlessIssuer) {
        cardlessIssuer.forEach((issuer) => {
          if (issuer.issuer_id === 400) hdfcIssuer = issuer;
          if (issuer.issuer_id === 401) iciciIssuer = issuer;
        });
      }
  
      setDcEMIIssuer(hdfcIssuer);
      setIciciDcEMIIssuer(iciciIssuer);
  
      const sortedIciciTenures = sortTenures(iciciIssuer?.tenures);
      const sortedHdfcTenures = sortTenures(hdfcIssuer?.tenures);
  
      setIciciEtbTenures(sortedIciciTenures);
      setHdfcEtbTenures(sortedHdfcTenures);
    }
  }, [paymentModeData]);

  useEffect(() => {
    const url =  process.env.REACT_APP_PG_CONTROLLER +
    "PinePGRedirect/DownloadKeyFactStatementforICICICardless?iIssuerId=" +
    iciciDcEMIIssuer?.issuer_id +
    "&Tenure=" + selectedTenure.tenure_id + 
    "&LoanAmount=" + (selectedTenure?.loan_amount / 100 || 0) + 
    "&TotalInterestCharge=" + (selectedTenure?.interest_pay_to_bank / 100 || "") + 
    "&PaymentMode=19" + "&EMIAmount=" + (selectedTenure?.monthly_installment / 100 || "") +
    "&InterestRate=" + (selectedTenure?.interest_rate
      ? selectedTenure?.interest_rate
      : selectedTenure?.bank_interest_rate / 10000) + 
    "&TotalAmount=" + (merchantPaymentData?.payment_data?.amount_in_paisa / 100 || 0);

    setKeyfactUrl(url);
  },[selectedTenure]);

  const checkPanCardEligible = (e) => {
    e.preventDefault();

    if ((isIcici && panNumber?.length === 10) || (!isIcici && panNumber?.length === 5)) {
      setSubmitButtonClicked(true);

      if ((isIcici && !panCardRegex.test(panNumber)) || (!isIcici && !last5digitsOfPanCardRegex.test(panNumber))) {
        setPanCardInputErrorMessage('Please enter valid details');
        setSubmitButtonClicked(false);
        return;
      }
      setPanCardInputErrorMessage('');

      checkPanCardEligibilityForCardlessEMIAction(token, {
        pan_number: isIcici ? encodeURIComponent(encryptedPan.toString()) : panNumber?.substring(0, 4),
        mobile_no: mobileNumber,
        scheme_id: selectedTenure?.applicable_scheme?.scheme_id,
        issuer_id: isIcici ? iciciDcEMIIssuer.issuer_id : dcEMIIssuer?.issuer_id,
        tenure_id: selectedTenure?.tenure_id,
        loan_amount: isIcici ? merchantPaymentData?.payment_data?.amount_in_paisa : selectedTenure?.loan_amount,
        interest_rate: selectedTenure?.bank_interest_rate,
        otp: '',
        acquirer_id: '',
        paymentmode_id: 19,
        emi_amount: selectedTenure?.monthly_installment,
      })
        .then((json) => {
          setSubmitButtonClicked(false);

          let responseData = json.data;
          if (responseData.response_code === 1) {
            setIsPanCardEligible(true);
            setPanCardErrorMessage('');
          } else if (responseData.response_code === -136) {
            setIsPanCardEligible(false);
            sessionExpires();
          } else if (
            [-60, -61, -62, -63, -64, -65, -66, -289].includes(
              responseData?.response_code || 0
            )
          ) {
            setSubmitButtonClicked(false);
            setIsPanCardEligible(false);
            setPanCardErrorMessage(
              'You have already availed an offer on this mobile number.'
            );
          } else {
            setSubmitButtonClicked(false);
            setIsPanCardEligible(false);
            setPanCardErrorMessage(isIcici ? 'You are not eligible for the ICICI cardless EMI.' : 
              'You are not eligible for the HDFC cardless EMI.'
            );
          }
        })
        .catch((error) => {
          console.log('onPanCardEligible:' + error);
          setSubmitButtonClicked(false);
        });
    } else {
      setIsPanCardEligible(false);
      setSubmitButtonClicked(false);
    }
  };

  const onSubmitOTP = (event) => {
    event.preventDefault();
    setSubmitButtonClicked(true);
    if (otp === null || otp?.length !== 6) {
      return;
    }

    checkSession(token)
      .then((json) => {
        let responseData = json.data;
        if (responseData.response_code === 1) {
          onValidateOTP((onValidateOTPResponse) => {
            if (onValidateOTPResponse) {
              setValidateOtpAPIResponse(onValidateOTPResponse);
              setShowOtpPopup(false);
              setShowHdfcEmiDetailsPopup(true);
            }
            setSubmitButtonClicked(false);
          });
        } else {
          sessionExpires();
          setShowOtpPopup(false);
          setSubmitButtonClicked(false);
        }
      })
      .catch((error) => {
        //alert("onHandleSubmit:" + error);
        setShowOtpPopup(false);
        setSubmitButtonClicked(false);
      });
  };

  const onValidateOTP = (callback) => {
    let valid = false;

    let validateOTPData = {
      pan_number: isIcici ? encodeURIComponent(encryptedPan.toString()) : panNumber?.substring(0, 4),
      mobile_no: mobileNumber,
      scheme_id: selectedTenure?.applicable_scheme?.scheme_id,
      issuer_id: isIcici ? iciciDcEMIIssuer?.issuer_id : dcEMIIssuer?.issuer_id,
      tenure_id: selectedTenure?.tenure_id,
      loan_amount: isIcici ? merchantPaymentData?.payment_data?.amount_in_paisa : selectedTenure?.loan_amount,
      interest_rate: selectedTenure?.bank_interest_rate,
      otp: otp,
      acquirer_id: '',
      paymentmode_id: 19,
      emi_amount: selectedTenure?.monthly_installment,
    };

    validateOTPForCardlessEMIAction(token, validateOTPData)
      .then((json) => {
        let responseData = json.data;
        if (responseData.response_code === 1) {
          callback(responseData.validate_otp_response);
        } else if (!responseData.validate_otp_response.IsMaxAttemptsExcceded) {
          setOTPValidationFailureMsg(
            'Please enter Valid OTP, ' +
              responseData.validate_otp_response.otp_attempts_left +
              ' Attempts Left'
          );

          callback(null);
        } else {
          setOTPValidationFailureMsg(
            'Max Attempts Reached, User now can  click on cancel button to re- initiate check eligibility call'
          );
          callback(null);
        }
      })
      .catch((error) => {
        setSubmitButtonClicked(false);
      });
    return valid;
  };

  const onTermAndConditionSubmitDebitEMI = (event) => {
    event.preventDefault();
    SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(true);
    setSubmitButtonClicked(true);
    checkSession(token)
      .then((json) => {
        let responseData = json.data;
        if (responseData.response_code === 1) {
          onClickDebitEMIConfirmOtp((responseCode) => {
            SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(true);
            document.getElementById('DebitEMIForm').submit();
            if (responseCode === 1) {
              setOrderConfirmationFailureMsg('');
              setSubmitButtonClicked(false);
            } else {
              setSubmitButtonClicked(false);
              setOrderConfirmationFailureMsg(
                'Something went wrong, please try again'
              );
            }
          });
        } else {
          sessionExpires();
          setShowHdfcEmiDetailsPopup(false);
          SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(false);
          setSubmitButtonClicked(false);
          setOrderConfirmationFailureMsg('');
        }
      })
      .catch((error) => {
        console.log('Error:' + error);
        setShowHdfcEmiDetailsPopup(false);
        SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(false);
        setSubmitButtonClicked(false);
        setOrderConfirmationFailureMsg('');
      });
  };

  const onClickDebitEMIConfirmOtp = (callback) => {
    let valid = -1;
    SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(true);
    let validateOTPData = {
      pan_number: isIcici ? encodeURIComponent(encryptedPan.toString()) : panNumber?.substring(0, 4),
      mobile_no: mobileNumber,
      scheme_id: selectedTenure?.applicable_scheme?.scheme_id,
      issuer_id: isIcici ? iciciDcEMIIssuer.issuer_id : dcEMIIssuer?.issuer_id,
      tenure_id: selectedTenure?.tenure_id,
      loan_amount: isIcici ? merchantPaymentData?.payment_data?.amount_in_paisa : selectedTenure?.loan_amount,
      interest_rate: selectedTenure?.bank_interest_rate,
      otp: otp,
      acquirer_id: '',
      paymentmode_id: 19,
      emi_amount: selectedTenure?.monthly_installment,
    };
    orderConfirmationWithPanCard(token, validateOTPData)
      .then((json) => {
        let responseData = json.data;
        valid = responseData.response_code;
        callback(valid);
      })
      .catch((error) => {
        console.log(error);
        setSubmitButtonClicked(false);
        setShowHdfcEmiDetailsPopup(false);
        setOrderConfirmationFailureMsg(
          'Something went wrong, please try again'
        );
        SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(false);
      });
  };

  const resendOtpFunction = () => {
    const resendOtpPayload ={
      pan_number: isIcici ? encodeURIComponent(encryptedPan.toString()) : panNumber?.substring(0, 4),
      mobile_no: mobileNumber,
      scheme_id: selectedTenure?.applicable_scheme?.scheme_id,
      issuer_id: isIcici ? iciciDcEMIIssuer.issuer_id : dcEMIIssuer?.issuer_id,
      tenure_id: selectedTenure?.tenure_id,
      loan_amount: isIcici ? merchantPaymentData?.payment_data?.amount_in_paisa : selectedTenure?.loan_amount,
      interest_rate: selectedTenure?.bank_interest_rate,
      otp: '',
      acquirer_id: '',
      paymentmode_id: 19,
      emi_amount: selectedTenure?.monthly_installment,
    };
    resendOTPForCardlessEMIAction(token, resendOtpPayload)
    .then((json) => {
      const response = json.data;
      if(response.response_code === 1){
        updateOtpResended(true);
      }
    }).catch((error) => {
      console.log(error);
    });
  };

  const debitEMIOtpPopup = (
    <PopUp
      onClose={() => {
        setShowOtpPopup(Boolean(false));
        setOtp('');
        setOTPValidationFailureMsg('');
      }}
      isContinueButtonToBeHide='true'
    >
      <div className='modal-body clearfix'>
        <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
          <h2>Enter OTP</h2>
          <p>OTP has been sent to your registered mobile no.</p>
        </div>
        <div className='col-lg-12 col-md-10 col-sm-10 col-12 col-centered enterotp mb-3'>
          <ValidatedInput
            className='form-control'
            type='text'
            id='OTPValue'
            name='OTPValue'
            value={otp}
            required=''
            placeholder='------'
            format='######'
            onValueChange={(values) => {
              const { value } = values;
              setOtp(value);
            }}
          />
          <label>
            <span className='dot mr-1'></span>
            <span className='dot mr-1'></span>
            <span className='dot mr-1'></span>
            <span className='dot mr-1'></span>
            <span className='dot mr-1'></span>
            <span className='dot mr-1'></span>
          </label>
        </div>
        {isIcici ? (
          <div
            className="col-12 resendOtp"
          >
            {otpResended ? (
              <div>
                <div className='resendOtpText'>Resend OTP in :&nbsp;</div>
                <span className="resendCounter text-right">
                  <CountDown
                    seconds={120}
                    onEnd={() => {
                      updateOtpResended(false);
                      clearResendOTPData();
                    }}
                  />
                </span>
              </div>
            ) : (
              <div
                className="text-green"
                onClick={() => {
                  resendOtpFunction();
                }}
              >
                Resend OTP
              </div>
            )}
          </div>
        ) : null}
        <div className='col-12 p-0'>
          <button
            className='btn btn-green'
            disabled={submitButtonClicked || !Boolean(otp && otp?.length === 6)}
            onClick={onSubmitOTP}
          >
            Continue{' '}
          </button>
          <button
            className='btn btn-grey'
            onClick={() => {
              setShowOtpPopup(Boolean(false));
              setOtp('');
              setOTPValidationFailureMsg('');
              setPanNumber('');
            }}
          >
            Cancel{' '}
          </button>
        </div>
        <div
          className='mt-4 justify-content-center'
          style={{ wordWrap: 'break-word' }}
        >
          {!isIcici && dcEMIIssuer?.terms_and_conditions}
        </div>
        <span className='error-block'>{OTPValidationFailureMsg}</span>
      </div>
    </PopUp>
  );

  const hdfcEmiDetailsPopup = (
    <PopUp
      onClose={() => {
        setShowHdfcEmiDetailsPopup(Boolean(false));
        setOtp('');
        setOTPValidationFailureMsg('');
        setValidateOtpAPIResponse('');
        setTermsAndConditionsCheckBox('');
      }}
      isContinueButtonToBeHide='true'
    >
      <div>
        <div class='col-lg-12 col-md-12 col-sm-12 col-xs-12 emi-tenure-header'>
          <h2>Payment Summary</h2>
        </div>
        <div class='col-12 paymentSummaryDetail'>
          {validateOtpAPIResponse?.customer_name ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>Customer name</p>
            </div>
            <div class='col-6 text-right'>
              <p>{validateOtpAPIResponse?.customer_name}</p>
            </div>
          </div> : null}
          {validateOtpAPIResponse?.merchant_name ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>Merchant name</p>
            </div>
            <div class='col-6 text-right'>
              <p>{validateOtpAPIResponse?.merchant_name}</p>
            </div>
          </div> : null}
          {validateOtpAPIResponse?.emi_amount_in_paise ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>EMI </p>
            </div>
            <div class='col-6 text-right'>
              <p>₹{validateOtpAPIResponse?.emi_amount_in_paise / 100}</p>
            </div>
          </div> : null}
          {validateOtpAPIResponse?.interest_rate ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>Interest</p>
            </div>
            <div class='col-6 text-right'>
              <p>{validateOtpAPIResponse?.interest_rate / 10000}%</p>
            </div>
          </div> : null}
          {validateOtpAPIResponse?.total_amount_in_paise ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>Amount </p>
            </div>
            <div class='col-6 text-right'>
              <p>₹{validateOtpAPIResponse?.total_amount_in_paise / 100}</p>
            </div>
          </div> : null}
          {validateOtpAPIResponse?.tenure_in_months ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>Tenure </p>
            </div>
            <div class='col-6 text-right'>
              <p>{validateOtpAPIResponse?.tenure_in_months} Months</p>
            </div>
          </div> : null}
          {validateOtpAPIResponse?.address ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>Address </p>
            </div>
            <div class='col-6 text-right'>
              <p>{validateOtpAPIResponse?.address}</p>
            </div>
          </div> : null}
          {validateOtpAPIResponse?.last6digitaccountnumber ? <div class='row emi-product-details'>
            <div class='col-6 text-left fw-600'>
              <p>Last 6 digit of your Account Number</p>
            </div>{' '}
            <div class='col-6 text-right'>
              <p>{validateOtpAPIResponse?.last6digitaccountnumber}</p>
            </div>
          </div> : null}
        </div>
        {!isIcici ? <div class='col-12 p-0 text-left note-text'>
          <div class='checkbox'>
            <input
              id='isTermAndConditionCheckBoxSet'
              name='isTermAndConditionCheckBoxSet'
              type='checkbox'
              onChange={(e) =>
                setTermsAndConditionsCheckBox(e?.target?.checked)
              }
              value={termsAndConditionsCheckBox}
            />
            <label htmlFor='isTermAndConditionCheckBoxSet'>
              {' '}
              I accept the{' '}
              <a
                href={
                  process.env.REACT_APP_PG_CONTROLLER +
                  'PinePGRedirect/DownloadHDFCDebitEMITermAndCondition?iIssuerId=' +
                 dcEMIIssuer?.issuer_id +
                  '&TnCDownload=true'
                }
              >
                <u> terms and conditions</u>
              </a>{' '} and 
              <a
                href={
                  process.env.REACT_APP_PG_CONTROLLER +
                  'PinePGRedirect/DownloadHDFCSchedulingCharges?iIssuerId=' +
                  dcEMIIssuer?.issuer_id +
                  '&TnCDownload=true'
                }
              >
                <u> schedule of charges</u>
              </a>{' '}
              of the HDFC bank.
            </label>
          </div>
        </div> : (
          <div className="terms-and-conditions">
            <div className="terms-agreement">
              <input
                id="isTermAndConditionCheckBoxSet"
                name="isTermAndConditionCheckBoxSet"
                type="checkbox"
                onChange={(e) =>
                  setTermsAndConditionsCheckBox(e?.target?.checked)
                }
                value={termsAndConditionsCheckBox}
              />
              <div className="terms-agreement-text">
              I agree to the terms and conditions, key fact statement and consent clause
              </div>
            </div>
            <div className="terms-download">
              <div className="terms-download-content">
                <a
                  href={
                    process.env.REACT_APP_PG_CONTROLLER +
                    "PinePGRedirect/DownloadHDFCDebitEMITermAndCondition?iIssuerId=" +
                    iciciDcEMIIssuer?.issuer_id +
                    "&TnCDownload=true"
                  }
                >
                  <img src={downloadIcon} alt="d" />
                  <u> Terms & Conditions</u>
                </a>
              </div>
              <div className="terms-download-content">
                <a
                  href={keyfactUrl}
                >
                  <img src={downloadIcon} alt="d" />
                  <u> Key fact Statement</u>
                </a>
              </div>
              <div className="terms-download-content">
                <a
                  href={
                    process.env.REACT_APP_PG_CONTROLLER +
                    "PinePGRedirect/DownloadICICICardlessConsentClause?iIssuerId=" +
                    iciciDcEMIIssuer?.issuer_id
                  }
                >
                  <img src={downloadIcon} alt="d" />
                  <u> Consent Clause</u>
                </a>
              </div>
            </div>
          </div>
        )}
        <div class='col-12 p-0 pull-right text-center'>
          <button
            class='btn btn-grey'
            onClick={() => {
              setShowHdfcEmiDetailsPopup(false);
              setOtp('');
              setOTPValidationFailureMsg('');
              setValidateOtpAPIResponse('');
              setTermsAndConditionsCheckBox('');
              setPanNumber('');
              setOrderConfirmationFailureMsg('');
            }}
            disabled={submitButtonClicked}
          >
            Cancel{' '}
          </button>
          <button
            class='btn btn-green'
            onClick={onTermAndConditionSubmitDebitEMI}
            disabled={submitButtonClicked || !termsAndConditionsCheckBox}
          >
            Continue{' '}
          </button>
        </div>
      </div>
      <span className='error-block'>{orderConfirmationFailureMsg}</span>
    </PopUp>
  );

  const eligibilityProps = {
    selectedBank,
    isProceedDisable,
    onProceed,
    hdfcEtbTenures,
    iciciEtbTenures,
    panNumber,
    setPanNumber,
    selectedTenure,
    setselectedTenure,
    checkPanCardEligible,
    submitButtonClicked,
    panCardInputErrorMessage,
    panCardErrorMessage,
    clearCheckEligibilityForCardlessEMIAction,
    merchantPaymentData,
    dcEMIIssuer,
    iciciDcEMIIssuer,
    setKeyfactUrl,
  };

  return (
    <div className='screen-2'>
      <div className='screen-2-title'>
        <img
          src={Back}
          alt='back'
          onClick={() => clearCheckEligibilityForCardlessEMIAction()}
        />
        <h2 id='cardless-emi-offers-title'>
          Select Bank / Loan Provider {`(for +91 ${mobileNumber})`}
        </h2>
      </div>
      <div className='col-12 p-0 bank-list'>
        <div className='row'>
          {cardlessEMIData?.issuers?.map((issuer) => (
            <div
              key={issuer?.name}
              className={`col-lg-3 col-md-3 col-sm-6 col-12 ${
                !issuer?.eligible ? `disabled` : ``
              }`}
            >
              <div
                className={`cardless-bank bank-list-names ${
                  !issuer?.eligible
                    ? `disabled`
                    : selectedBank?.name === issuer?.name
                    ? 'active'
                    : ''
                }`}
                onClick={() => {
                  if (!issuer?.eligible) return false;
                  setSelectedBank(issuer);
                  setDefaultState();
                }}
              >
                <div>
                  <img
                    width={32}
                    src={`../../${process.env.PUBLIC_URL}/images/banks/${
                      issuer?.name?.split('_')[0]
                    }.png`}
                    alt=''
                  />
                  {issuer?.name?.split('_')[0]}{' '}
                </div>
                <div style={{ padding: '0px 6px' }}>
                  <div className='col-12 divider'></div>
                </div>
                <div className='status-text'>
                  {(issuer?.name?.split('_')[0] === 'HDFC' || issuer?.name?.split('_')[0] === 'ICICI') ? (
                    <span>Please continue to check eligibility</span>
                  ) : issuer?.eligible ? (
                    <span className='eligible-text'>You’re Eligible</span>
                  ) : (
                    <span className='not-eligible-text'>Not Eligible!</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='col-12 divider'></div>

      <BankDetails 
        {...eligibilityProps}
      />

      {showOtpPopup ? debitEMIOtpPopup : ''}
      {showHdfcEmiDetailsPopup ? hdfcEmiDetailsPopup : ''}
      <form
        id='DebitEMIForm'
        method='post'
        action={
          process.env.REACT_APP_PG_CONTROLLER +
          'pinepg/v2/cardless/pan/submit/emi?token=' +
          encodeURIComponent(token)
        }
      >
        <input
          type='hidden'
          id='PanNumber'
          name='PanNumber'
          value={isIcici ? panNumber : panNumber?.substring(0, 4)}
        />
        <input
          type='hidden'
          id='MobileNo'
          name='MobileNo'
          value={mobileNumber}
        />
        <input
          type='hidden'
          id='PaymentModeId'
          name='PaymentModeId'
          value='19'
        />
        <input
          type='hidden'
          id='IssuerId'
          name='IssuerId'
          value={isIcici ? iciciDcEMIIssuer?.issuer_id : dcEMIIssuer?.issuer_id}
        />
        <input
          type='hidden'
          id='SchemeId'
          name='SchemeId'
          value={selectedTenure?.applicable_scheme?.scheme_id}
        />
        <input
          type='hidden'
          id='TenureId'
          name='TenureId'
          value={selectedTenure?.tenure_id}
        />
        <input
          type='hidden'
          id='InterestRate'
          name='InterestRate'
          value={selectedTenure?.bank_interest_rate}
        />
        <input
          type='hidden'
          id='LoanAmount'
          name='LoanAmount'
          value={selectedTenure?.loan_amount}
        />
        <input type='hidden' id='otpValue' name='otpValue' value={otp} />
      </form>
    </div>
  );
};

export default ProcessScreen;
